import { Link } from "react-router-dom";
import Loader from "./loader";
import stringHelpers from "../../utilities/stringHelpers";
export const InfoWidget = ({ title, content, cta, icon, isLoading, handleRefreshClick, children }) => {
    const hasTitle = !stringHelpers.isNullOrEmpty(title)
    const hasCta = cta && !stringHelpers.isNullOrEmpty(cta.pathname)
    const ctaLabel = cta && !stringHelpers.isNullOrEmpty(cta.label) ? cta.label : "See all"
    const hasHeaderActions = !!handleRefreshClick

    return (
        <div className="card info-widget h-100">
            <div className={ `card-body d-flex ${ hasHeaderActions ? `flex-column align-items-center justify-content-${ isLoading ? "center" : "start" }` : `justify-content-center align-items-${ isLoading ? "center" : "start" }` }` }>
                {
                    hasHeaderActions &&
                    <div className="d-flex align-items-center justify-content-between w-100 mb-2">
                        {hasTitle && <p className="m-0 fs--1 font-weight-bold text-nowrap">{ title }</p>}
                        <div className="d-flex align-items-center">
                            <button onClick={ () => handleRefreshClick() } className="btn btn-none m-0 p-0">
                                <i className="fas fa-sync d-flex align-items-center ml-2"></i>
                            </button>
                            {
                                hasCta &&
                                <Link
                                    className="d-flex align-items-center fs--1 text-secondary font-weight-bold ml-3"
                                    to={ { pathname: cta.pathname, state: cta.forwardingProps } }>
                                    <p className="m-0 text-nowrap">{ ctaLabel }</p> <i className="m-0 ml-2 fas fa-chevron-right"></i>
                                </Link>
                            }
                        </div>
                    </div>
                }
                {
                    isLoading
                        ? <div className="tiny-loader">
                            <Loader />
                        </div>
                        : <div className="d-flex flex-column align-items-start w-100 relative">
                            {hasTitle && !hasHeaderActions && <p className="m-0 mb-2 fs--1 font-weight-bold">{ title }</p>}
                            {content !== null && <div className="mb-2 fs-3">{ content }</div>}
                            {
                                hasCta && !hasHeaderActions &&
                                <Link
                                    className="d-flex align-items-center fs--1 text-secondary font-weight-bold"
                                    to={ { pathname: cta.pathname, state: cta.forwardingProps } }>
                                    <p className="m-0">{ ctaLabel }</p> <i className="m-0 ml-2 fas fa-chevron-right"></i>
                                </Link>
                            }
                            {
                                icon && !stringHelpers.isNullOrEmpty(icon.class) &&
                                <i className={ `${ icon.class } text-${ !stringHelpers.isNullOrEmpty(icon.colour) ? icon.colour : "default" } info-widget-icon` }></i>
                            }
                            { children && <div className="w-100">{ children }</div> }
                        </div>
                }
            </div>
        </div>
    )
}
